export enum EToolButtonType {
  TOOL_BUTTON = 'tool-button',
  REGULAR_BUTTON = 'regular-button',
}

export const TOOL_BUTTON_TYPES = {
  TOOL_BUTTON: EToolButtonType.TOOL_BUTTON,
  REGULAR_BUTTON: EToolButtonType.REGULAR_BUTTON,
};
